import { memo, lazy, Suspense } from 'react';
import { Router } from '@reach/router';
import GuardRoute from '@router/GuardRoute';
import { ROUTES } from '@utils/constants';
import { importRetry } from '@router/utils';

const Login = lazy(() =>
    importRetry(() => import('@pages/mobile/login/Login')),
);
const Agenda = lazy(() =>
    importRetry(() => import('@pages/desktop/agenda/Agenda')),
);
const Settings = lazy(() =>
    importRetry(() => import('@pages/desktop/settings/Settings')),
);

const { PUBLIC_URL } = process.env;
const redirectIfLogged = (isAuthed: boolean) => !isAuthed;

const DesktopRoutes = (): JSX.Element => (
    <Suspense fallback={<div />}>
        <Router basepath={PUBLIC_URL || '/'}>
            <GuardRoute
                condition={redirectIfLogged}
                component={Login}
                redirect={ROUTES.AGENDA}
                path={ROUTES.LOGIN}
            />
            <GuardRoute default component={Agenda} path='/' />
            <GuardRoute component={Agenda} path={`${ROUTES.AGENDA}/*`} />
            <GuardRoute component={Settings} path={`${ROUTES.SETTINGS}/*`} />
        </Router>
    </Suspense>
);

export default memo(DesktopRoutes);
